import { SideNav, SideNavContent } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import BaseDateInput from "components/UniversalComponents/BaseDateInput";
import UploadFile from "components/UploadFile";
import { BaseInput, LargeButton, PageTitle } from "components/core";
import routes from "components/routes";
import { Form, Formik } from "formik";
import { ButtonWrapper } from "pages/PlanSelection";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import http from "services/httpService";
import { formatDate, formatDateReverse } from "utlis/utils";

function Collect() {
  const [excelId, setExcelId] = useState();
  const isPostIssuance = localStorage.getItem("gmc_details");
  const navigate = useNavigate();
  const uploadData = async (values) => {
    try {
      const { cutoff_date } = values;
      const payload = {
        cutoff_date: formatDate(cutoff_date),
        employee_data_excel_id: excelId,
      };
      const { data } = await http.post(
        "/business/upload_employee_data_collection/",
        payload
      );
      console.log(data);
      localStorage.setItem("super_task_id", data);
      navigate("/v1/data-collection-history/collect/pending", { state: { cutoff_date } });
    } catch (e) {
      alert(e.response.data);
    }
  };
  const downloadExcel = async () => {
    const { data } = await http.post(
      "business/generate_dynamic_upload_employee_dc_sheet/",
      {},
      { responseType: "blob" }
    );
    console.log(data);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "data_collection_file.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };
  return (
    <>
    <WidthLimiter>
 <Formik
        // validationSchema={{}}
        initialValues={{ cutoff_date: "" }}
        onSubmit={(values) => uploadData(values)}
      >
        {(formikProps) => (
          <Form>
            <UploadFile
              headerMargin="12px 0"
              sampleFile="FlexEmployeeSheet"
              onDownload={() => downloadExcel()}
              label="Upload Data"
              text="Upload File"
              format="excel"
              type="policy_upload_excel" //anshul will provide new type
              onSelect={setExcelId}
            />
            <div style={{ maxWidth: "400px" }}>
              {/* <BaseInput
                    staticLabel="Set Cut-off Date for Data Collection"
                    date
                    fontSize="16px !important"
                    formikProps={{ ...formikProps, name: "cutoff_date" }}
                  /> */}
              <BaseDateInput
                staticLabel="Set Cut-off Date for Data Collection"
                onlyFutureDate={true}
                formikProps={{ ...formikProps, name: "cutoff_date" }}
              />
            </div>
            <ButtonWrapper>
              <LargeButton id="upload data" label="Save & Next" type="submit" 
   />
            </ButtonWrapper>
          </Form>
        )}
      </Formik>
    </WidthLimiter>
     
    </>
  );
}

export default Collect;
